import React from 'react';
import styled from 'styled-components';
import { UrlItem } from './url-item.component';
import { useDeleteConfirmation } from '../../../hooks/use-delete-confirmation.hook';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var Container = styled.div.withConfig({
  displayName: "url-listcomponent__Container",
  componentId: "sc-ibyakm-0"
})(["display:flex;flex-direction:column;gap:12px;"]);
var ListHeader = styled.div.withConfig({
  displayName: "url-listcomponent__ListHeader",
  componentId: "sc-ibyakm-1"
})(["font-size:12px;font-weight:700;color:#8b95b0;text-transform:uppercase;letter-spacing:0.05em;margin-bottom:4px;"]);
var ListContent = styled.div.withConfig({
  displayName: "url-listcomponent__ListContent",
  componentId: "sc-ibyakm-2"
})(["display:flex;flex-direction:column;gap:8px;max-height:240px;overflow-y:auto;padding-right:4px;&::-webkit-scrollbar{width:4px;}&::-webkit-scrollbar-track{background:transparent;}&::-webkit-scrollbar-thumb{background:#e0e4ef;border-radius:4px;}"]);
export var UrlList = function UrlList(_ref) {
  var urls = _ref.urls,
      onRemove = _ref.onRemove;

  var _useDeleteConfirmatio = useDeleteConfirmation({
    itemType: 'url',
    itemName: 'URL'
  }),
      confirmDelete = _useDeleteConfirmatio.confirmDelete;

  var handleRemove = function handleRemove(urlData) {
    confirmDelete(function () {
      onRemove(urlData.id);
    });
  };

  if (urls.length === 0) return null;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(ListHeader, {
      children: ["ADDED URLS (", urls.length, ")"]
    }), /*#__PURE__*/_jsx(ListContent, {
      children: urls.map(function (urlData) {
        return /*#__PURE__*/_jsx(UrlItem, {
          url: urlData.url,
          onRemove: function onRemove() {
            return handleRemove(urlData);
          }
        }, urlData.id);
      })
    })]
  });
};